import type { DataTableColumn } from '@/components/custom/erp';
import type { Group } from '@/types/schemas';

export const factorGroupColumns: DataTableColumn<Group>[] = [
  { field: 'ma_nhom', headerName: 'Mã nhóm', width: 150 },
  { field: 'ten_phan_nhom', headerName: 'Tên nhóm', width: 250 }
];
